<template>
    <div>
        <el-row>
            <el-col>
                <el-card shadow="never">
                    <h1 style="text-align:left;margin-top:unset;">Edited Order Log</h1>
                    <el-row :span="24">
                        <el-col class="text-md-left">
                            <el-form label-position="top" label-width="100px" @submit.native.prevent="() => {}">
                                <el-form-item label="เลือกวันที่ต้องการ">
                                    <el-date-picker
                                        v-model="datePick"
                                        type="daterange"
                                        range-separator="To"
                                        start-placeholder="Start date"
                                        end-placeholder="End date">
                                    </el-date-picker>
                                    <el-button type="primary" style="margin-left:10px;" @click="FetchLogEditOrder">ค้นหา </el-button>
                                </el-form-item>
                            </el-form>
                        </el-col>
                        <el-col>
                        <div style="margin-bottom: 10px">
                            <el-row>
                                <el-col :span="6">
                                <el-input v-model="filters[0].value" placeholder="ค้นหาชื่อร้านค้า"></el-input>
                                </el-col>
                            </el-row>
                        </div>
                            <data-tables
                                :data="shopArray"
                                style="width: 100%"
                                :filters="filters"

                                class="dataTable">
                                <el-table-column prop="shopName" label="Shop Name" width="250"></el-table-column>
                                <el-table-column label="จำนวนออเดอร์" width="180">
                                    <div class="text-md-left" slot-scope="scope">
                                        <span style="margin-right: 30px;" > {{CountOrderResult(scope.row.orders)}}</span>
                                        <i class="el-icon-info" @click="showDetail(scope.row.orders)"></i>
                                    </div>
                                </el-table-column>
                                <el-table-column label="ยังไม่ได้รีปริ้น" width="180">
                                    <div class="text-md-left" slot-scope="scope">
                                        <span style="margin-right: 30px;" > {{CountOrderReprint(scope.row.orders)}}</span>
                                    </div>
                                </el-table-column>
                            </data-tables>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <dialog-edit-order  :dialogShow="dialogShopShow"
                            @closeModal="dialogShopShow = false"
                            :orderDetail="orderDetail"
        ></dialog-edit-order>
    </div>
</template>
<script>
import mixinExcel from '@/mixins/exportExcel.js'
import fgApi from '@/services/fillgoods'
import DialogEditOrder from '@/components/LogOrder/DialogEditOrder'
export default {
    name: 'ExportStatusOrder',
    mixins: [mixinExcel],
    components: { DialogEditOrder },
    data () {
        return {
            datePick: null,
            shopArray: [],
            dialogShopShow: false,
            orderDetail: [],
            filters: [
                {
                    prop: 'shopName',
                    value: ''
                }
            ]
        }
    },
    created () {
        let dateTo = new Date()
        let dateFrom = new Date()
        dateFrom.setDate(dateTo.getDate() - 14)
        this.datePick = [dateTo, dateTo]
    },
    methods: {
        async FetchLogEditOrder () {
            this.$loading({
                text: 'กำลังโหลดข้อมูล...'
            })
            let dateFrom = this.datePick[0].getFullYear() + '-' + String(this.datePick[0].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[0].getDate()).padStart(2, '0') + ' 00:00:00'
            let dateTo = this.datePick[1].getFullYear() + '-' + String(this.datePick[1].getMonth() + 1).padStart(2, '0') + '-' + String(this.datePick[1].getDate()).padStart(2, '0') + ' 23:59:59'
            let param = {
                shop_id: null,
                from: dateFrom,
                to: dateTo,
                status: null
            }
            console.log(param)
            try {
                let res = await fgApi.log.editOrderLog(param)
                console.log(res)
                if (res.success) {
                    this.shopArray = res.data
                }
            } catch (error) {
                console.log(error)
            }
            this.$loading().close()
        },
        CountOrderResult (val) {
            return val.length
        },
        showDetail (data) {
            this.dialogShopShow = !this.dialogShopShow
            this.orderDetail = data
        },
        CountOrderReprint (data) {
            console.log(data)
            let sumReprint = data.filter(e => e.isReprint === true)
            return sumReprint.length
        }
    }
}
</script>

<style lang="scss">
    .el-icon-info{
        cursor: pointer;
    }
    .dataTable{
        .el-table .cell {
            font-size: 16px;
        }
        th{
            background-color: black;
            color: white;
        }
    }

</style>
